/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

/**
 * ContractDescription Component
 * @param contract
 * @returns {JSX.Element}
 * @constructor
 */
export default function ContractDescription({ contract }) {
  /**
     * @returns {JSX.Element}
     */
  const renderSubDescription = (description) => {
    if (description) {
      const descriptionParts = description.split('-');
      return descriptionParts.map((descPart) => (
        <li key={`subdescription-${uuidv4()}`} className="service-subdescription">
          <CheckCircleIcon fontSize="small" />
          <span>{descPart}</span>
        </li>
      ));
    }
    return null;
  };

  return (
    <Grid item xs={12} className="additional-services-wrapper">
      <Box className="service-descriptions">{contract?.description}</Box>
      <Box className="service-subdescriptions">
        <ul>
          {renderSubDescription(contract?.subDescription)}
        </ul>
      </Box>
      <Box className="service-footnote">{contract?.footnote}</Box>
    </Grid>
  );
}

ContractDescription.propTypes = {
  contract: PropTypes.object.isRequired,
};
